// extracted by mini-css-extract-plugin
export var content_wrapper = "styles-module--content_wrapper--f2bb8";
export var productUpdate = "styles-module--productUpdate--8f5d2";
export var wrapper = "styles-module--wrapper--c23b9";